import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProducts, showProduct, resetSearch } from '../../actions/product';
import { setProduct } from '../../actions/product';
import { fetchByCategory, setCurrentCategoryIndex, setActiveCategoryIndex } from '../../actions/api';

import ProductContainerRender from "../ProductContainerRender/ProductContainerRender";
import { getProducts } from '../../selectors/product_selector';
import { getCategories } from '../../selectors/configSelectors';
import { pushWithQueryParams } from '../../services/uri';

class ProductContainer extends Component {
  getCategoryParam = () => {
      return this.props.match.params.category;
  }
 
  componentDidMount() {
    this.props.resetSearch();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.queryString !== nextProps.queryString && this.props.queryParams.customerType === nextProps.queryParams.customerType) {
      this.props.resetSearch();
    }
  }

  render() {
    return <ProductContainerRender/>;
  }
}

const mapStateToProps = (state) => {
  return {
    router : state.router,
    products: getProducts(state),
    categories: getCategories(state),
    view: state.view,
    queryString: state.uri.queryString,
    queryParams: state.uri.queryParams,
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
      fetchByCategory: (name)=> dispatch(fetchByCategory(name, 0, 20)),
      setCurrentCatIdx: (idx) => dispatch(setCurrentCategoryIndex(idx)),
      go: (path) => dispatch(pushWithQueryParams(path)),
      showProduct: (index) => dispatch(showProduct(index)),
      fetchProducts: () => dispatch(fetchProducts()),
      setCurrentProduct: (product) => dispatch(setProduct(product)),
      setActiveCatIdx: (idx) => dispatch(setActiveCategoryIndex(idx)),
      resetSearch: () => dispatch(resetSearch())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductContainer);



// WEBPACK FOOTER //
// ./src/components/ProductContainerSearch/ProductContainerSearch.jsx